// Show flash messages.

export const PUSH_FLASH_MESSAGE = 'PUSH_FLASH_MESSAGE';
export const CLEAR_FLASH_MESSAGE = 'CLEAR_FLASH_MESSAGE';

export const pushFlashMessage = (message, className = '', flashId = null) => ({
  type: PUSH_FLASH_MESSAGE,
  message: {
    id: flashId || Date.now(),
    className,
    message,
  },
});

export const clearFlashMessage = id => ({
  type: CLEAR_FLASH_MESSAGE,
  id,
});



// WEBPACK FOOTER //
// ./app/javascript/common/actions.js